module.exports = __webpack_public_path__ + "static/media/fuel.426e6d3a.svg";